module.exports = __webpack_public_path__ + "media/country_flags/it-414b93f2.png";